import {convertToInt} from '@utils/helpers';

const ALIGN_LEFT = {
    header: { align: 'left' },
    content: { align: 'left' },
};
const ALIGN_CENTER = {
    header: { align: 'center' },
    content: { align: 'center' },
};

export const sequenceConfigColumns = {
    'id': {
        label: 'ID',
        sorting: (row) => convertToInt(row.id),
        ...ALIGN_CENTER,
    },
    'name': {
        label: 'Name',
        sorting: true,
        ...ALIGN_LEFT,
    },
    'data_source': {
        label: 'Data source',
        sorting: (row) => row.sequence_data_source?.name,
        ...ALIGN_LEFT,
    },
    'start_delay': {
        label: 'Start delay',
        sorting: true,
        ...ALIGN_LEFT,
    },
    'stop_delay': {
        label: 'Stop delay',
        sorting: true,
        ...ALIGN_LEFT,
    },
    'cutoff': {
        label: 'Cutoff',
        sorting: true,
        ...ALIGN_LEFT,
    },
    'actions': {
        label: 'Actions',
        ...ALIGN_CENTER,
    },
};
